import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import { Link } from 'react-router-dom';
import Titulo from '../comum/Titulo';
import {
    getFinanceiroAgencia,
    getFinanceiroCaixa,
    getPerfisEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { buscarBagagens, alterarExibicaoBagagem } from '../../actions/bagagem/bagagemActions';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import Bagagem from './Bagagem';
import PainelFiltragem from './PainelFiltrosBagagem';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import { alterouFiltro, alterouPagina } from '../../util/filtros';

export const CabecalhoTabela = () => (
  <div className="vx-list-header vx-list-header--bagagem">
    <div className="vx-list-header-cell">Detalhes</div>
    <div className="vx-list-header-cell">Nº Reserva</div>
    <div className="vx-list-header-cell">Identificador</div>
    <div className="vx-list-header-cell">Passageiro</div>
    <div className="vx-list-header-cell">Vendedor</div>
    <div className="vx-list-header-cell">Situação</div>
    <div className="vx-list-header-cell">Data emissão</div>
    <div className="vx-list-header-cell">Valor</div>
    <div className="vx-list-header-cell">Peso</div>
    <div className="vx-list-header-cell">Ações</div>
  </div>
);

export class PainelGerenciarBagagenss extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            arquivos: [],
            imagensInformarEntrega: [],
            historicos: [],
            idPedido: null
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.buscarBagagens();
        }
    }

    buscarBagagens() {
        this.props.buscarBagagens(
            this.props.empresaSelecionada.id,
            this.props.paginaAtual,
            this.props.registrosPorPagina,
            this.props.filtrosAdicionados
        );
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarBagagens();
        }
    }

    exibirBagagens() {
        return this.props.bagagens.map((bagagem, index) => (
            <Bagagem key={index} bagagem={bagagem} indice={index}/>
        ));
    }

    exibirTabelaBagagens() {
        if (this.props.bagagens && this.props.bagagens.length) {
            return (
                <div className="vx-list-container">
                    <CabecalhoTabela/>
                    {this.exibirBagagens()}
                </div>
            );
        }
        return (
            <div className="vx-list-container">
                <div className="vx-empty-state">
                    <span className="material-icons">work</span>
                    <p>Nenhuma bagagem cadastrada</p>
                </div>
            </div>
        );
    }

    exibirFiltro() {
        return (
            <div className="col-12" style={{marginBottom: 12}}>
                <div className="vx-page-toolbar">
                    <div>
                        <Link to="/painel-pesquisar-bilhete">
                            <button className="vx-toolbar-btn">
                                <span className="material-icons">add</span>
                                Nova Bagagem
                            </button>
                        </Link>
                    </div>
                    <div>
                        <PainelFiltragem/>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, ...getPerfisEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="row internas">
                    <Titulo texto="Gerenciar bagagens" urlRetorno="/menu-bagagem"/>
                    {this.exibirFiltro()}
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <div className='col-12'>
                            <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                <li className="nav-item dropdown nome-empresa">
                                    <div className='col-md-6'>
                                        <CampoSelecionarEmpresa/>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Autorizacao>
                    <div className='col-12'>
                        {this.exibirTabelaBagagens()}
                    </div>
                </div>
            </Autorizacao>
        );
    }
}


export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
    bagagens: state.bagagem.lista,
    paginaAtual: state.paginaAtualBagagem,
    registrosPorPagina: state.registrosPorPaginaBagagem,
    filtrosAdicionados: state.filtrosAdicionadosBagagem,
    bagagemSelecionada: state.bagagemSelecionada,
    changeFieldValue,
});


export default connect(mapStateToProps, {
    buscarBagagens,
    alterarExibicaoBagagem,
})(PainelGerenciarBagagenss)
